import { isDbModule } from "helpers/module";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getModule } from "store/userSlice";
import { useTranslation } from "translation/useTranslation";

export default function ActionChangePreview({ whoList = [], whatItems = [], perInstance = false, count = null, actionType = null, showWhoList = true, whoTitle = null, whoCountTemplate = null }) {
  const { editableTranslate, editableTranslateString } = useTranslation();

  const affected = count ?? whoList.length;

  const currentModule = useSelector(getModule);
  const isDbModuleActive = useMemo(() => isDbModule(currentModule), [currentModule]);

  const renderWhatItems = (items) => (
    <ul className="pl-4 mb-0">
      {items.map((item, i) => <li key={i}>{item.label}{item.value ? ' -> ' + item.value : ''}</li>)}
    </ul>
  );

  const scopeTitle = useMemo(() => {
    if (actionType === 'create_balanced_scorecard') {
      if(isDbModuleActive) return editableTranslate('action.detail.create_evaluation', 'Beurteilung erstellen');
      else return editableTranslate('action.detail.create_balanced_scorecard', 'Leistungskarte anlegen');
    } else if (actionType === 'change_first_scorecard') {
      if(isDbModuleActive) return editableTranslate('action.detail.change_first_evaluation', 'Erste Beurteilung ändern');
      else return editableTranslate('action.detail.change_first_scorecard', 'Erste Leistungskarte ändern');
    }

    return editableTranslate('action.detail.preview.scope_of_change', 'Umfang der Änderung');
  }, [actionType, isDbModuleActive, editableTranslate]);

  return (
    <div>
      {
        !perInstance && whatItems.length > 0 && (
          <div className="mb-3">
            <div className="font-weight-bold">{scopeTitle}</div>
            <hr className="my-2" />
            {renderWhatItems(whatItems)}
          </div>
        )
      }

      <div className="mt-4">
        <div className="font-weight-bold">{whoTitle ?? editableTranslate('action.detail.preview.selected_employees', 'Ausgewählte Beschäftigte')}</div>
        <hr className="my-2" />
        <div className="mb-2" dangerouslySetInnerHTML={{
          __html: (whoCountTemplate ?? editableTranslateString('action.detail.preview.who_count', '$X Beschäftigte')).replace('$X', affected)
        }} />
        {showWhoList && (
          whoList.length > 0
            ? <ul className="pl-4 mb-0 action-change-preview-list">
              {whoList.map((emp) => (
                <li key={emp.hash_id} className="mb-1">
                  <span>{emp.name}</span>
                  {emp.employee_number ? <span className="text-muted ml-1">({emp.employee_number})</span> : null}
                  {
                    perInstance && emp.whatItems && emp.whatItems.length > 0 &&
                    renderWhatItems(emp.whatItems)
                  }
                </li>
              ))}
            </ul>
            : <div className="text-muted" data-testid="empty-state">{editableTranslate('global.no_data', 'Keine Daten')}</div>
        )}
      </div>
    </div>
  );
}
